import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface SettingsFavoritesState {
  favoriteIds: string[]
  recentIds: string[]
  toggleFavorite: (id: string) => void
  isFavorite: (id: string) => boolean
  trackRecent: (id: string) => void
}

const MAX_RECENT = 8

export const useSettingsFavoritesStore = create<SettingsFavoritesState>()(
  persist(
    (set, get) => ({
      favoriteIds: [],
      recentIds: [],
      toggleFavorite: (id) =>
        set((state) => {
          const exists = state.favoriteIds.includes(id)
          return {
            favoriteIds: exists
              ? state.favoriteIds.filter((x) => x !== id)
              : [id, ...state.favoriteIds].slice(0, 24),
          }
        }),
      isFavorite: (id) => get().favoriteIds.includes(id),
      trackRecent: (id) =>
        set((state) => ({
          recentIds: [id, ...state.recentIds.filter((x) => x !== id)].slice(0, MAX_RECENT),
        })),
    }),
    {
      name: 'settings-favorites',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
